<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.subject schedule") }}</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight px-0">    
    <div class="row">
      <div v-if="roleprivileges.includes('Subject Schedule Subject Schedule Tree')" class="col-lg-6 mb-1 pr-0">
          <div class="ibox-content horizondalscroll minheight">
            <ul class="tree pl-1">
              <li>
                <input type="checkbox" id="study-name" />
                <label class="tree_label" for="study-name">{{ studyRef }}</label>
                <ul>
                  <li v-for="(site, sIndex) in sites" :key="site.siteID">
                    <input type="checkbox" :id="site.siteID" @change="getpatient(site.siteID, sIndex)" />
                    <label class="tree_label" :for="site.siteID">{{ site.siteCode }}</label>
                    <ul v-for="(patient, pIndex) in patientLists[sIndex]" :for="site.siteID" :key="patient.patientId">
                      <li>
                        <input type="checkbox" :id="patient.patientId" @change="getVisits(patient.patientId, pIndex)" />
                        <label :for="patient.patientId" class="tree_label">{{
                          patient.subjectId
                          }}</label>
                    <ul v-if="hasadditionalforms[patient.patientId]">
                      <li>
                        <input
                          type="checkbox"
                          :id="patient.patientId + 'additionalforms'"
                          @change="getAdditionalForms(patient.patientId)"
                        />
                        <label :for="patient.patientId + 'additionalforms'" class="tree_label">
                          Additional forms
                        </label>
                      </li>

                    <!-- Grouped Forms with Collapsible Folders -->
                    <ul v-if="groupedAdditionalForms[patient.patientId] && additionalformchecked[patient.patientId]">
                      <li
                        v-for="(group, templateId) in groupedAdditionalForms[patient.patientId]"
                        :key="templateId"
                        class="group-folder-item"
                      >
                        <!-- Collapsible Group Folder with Checkbox -->
                        <input
                          type="checkbox"
                          :id="patient.patientId + templateId + 'group'"
                          :checked="expandedAdditionalGroups[patient.patientId] && expandedAdditionalGroups[patient.patientId][templateId]"
                          @change="toggleAdditionalGroup(patient.patientId, templateId)"
                        />
                        <label
                          :for="patient.patientId + templateId + 'group'"
                          class="tree_label tree_folder_label"
                        >
                          {{ group.templateName }} ({{ group.forms.length }})
                        </label>

                        <!-- Individual Forms - Shown only when group is expanded -->
                        <ul
                          v-if="expandedAdditionalGroups[patient.patientId] && expandedAdditionalGroups[patient.patientId][templateId]"
                          class="group-forms-list"
                        >
                          <li v-for="form in group.forms" :key="form.formId">
                            <input
                              type="checkbox"
                              :id="form.formId + patient.patientId + site.siteCode"
                              @click.prevent="gotoform(form, patient.subjectId, site.siteCode)"
                            />
                            <label
                              class="tree_label"
                              :for="form.formId + patient.patientId + site.siteCode"
                              @click.stop
                            >
                            {{
                              // form.formStatus === "Completed"
                              // ? form.templateName +
                              // " - " +
                              // (form.visitCompletedDate
                              // ? filter(form.visitCompletedDate) + "-"
                              // : "")
                              // : form.templateName
                                form.formStatus === 'Completed'
                                ? form.templateName + ' (' + form.version + ') - ' + form.languageCode?.toUpperCase() +
                                ' - ' +
                                (form.visitCompletedDate
                                ? filter(form.visitCompletedDate) + '-'
                                : '')
                                : form.templateName + ' (' + form.version + ') - ' + form.languageCode?.toUpperCase()
                                }}

                                                            
                                  <span class="badge custom-form-tooltip-wrapper"
                                      :style="`background-color: ${form.formStatusHex}; color: black;`">
                                      {{ form.formStatus }}</span>

                            </label>
                          </li>
                        </ul>
                      </li>
                    </ul>
                </ul>
                        <!-- <ul v-for="(visit, vIndex) in visitobj[patient.patientId][pIndex]" :for="patient.patientId"
                          :key="visit.sheduleId"> -->
                      <ul>
                        <li v-for="(node, nodeIndex) in visitTreeObj[patient.patientId]"
                          :key="nodeIndex"
                        >  
                          <template v-if="node && node.type === 'visit'">
                            <input type="checkbox" :id="node.visit.sheduleId + patient.patientId" @change="
                              getactivities(
                                patient.patientId,
                                node.visit.visitNo,
                                node.visit.visitName,
                                node.visit.__visitIndex,
                                node.visit.sheduleId,
                                site.siteCode, 
                                node.visit.patientNo
                              )
                              " />
                            <div class="tree-row">
                              <label :for="node.visit.sheduleId + patient.patientId" class="tree_label">
                                {{ node.visit.visitNo }} - {{ node.visit.visitName }} - ( {{ setdate(node.visit) }} )
                                <span class="badge custom-tooltip-wrapper"
                                  @mouseenter="showPopover(`visitStatus-${sIndex}-${pIndex}-${nodeIndex}`)"
                                  @mouseleave="hidePopover(`visitStatus-${sIndex}-${pIndex}-${nodeIndex}`)"
                                  :popovertarget="`visitStatus-${sIndex}-${pIndex}-${nodeIndex}`"
                                  :style="`background-color: ${node.visit.visitStatusHex}; color: black; anchor-name:--visitStatus-${sIndex}-${pIndex}-${nodeIndex};`">
                                  {{ node.visit.visitStatus }}</span><span class="custom-tooltip-text"
                                  v-if="node.visit.visitStatusDescription" popover
                                  :id="`visitStatus-${sIndex}-${pIndex}-${nodeIndex}`"
                                  :style="`position-anchor:--visitStatus-${sIndex}-${pIndex}-${nodeIndex};`">{{
                                  node.visit.visitStatusDescription }}</span>
                              </label>
                              <span v-if="roleprivileges.includes('Subject Schedule Assign ePRO Form') ||
                                roleprivileges.includes('Subject Schedule Video Call') ||
                                roleprivileges.includes('Subject Schedule Plan Next Visit') ||
                                roleprivileges.includes('Subject Schedule Change Visit Date') ||
                                roleprivileges.includes('Subject Schedule Change Planned Date') ||
                                roleprivileges.includes('Subject Schedule Manage Visit') ||
                                roleprivileges.includes('Subject Schedule Add Unscheduled Visit') ||
                                roleprivileges.includes('Subject Schedule Change Visit Status')"
                                class="tree-actions position-relative cursor-pointer px-2"
                                @click.prevent="toggleSidePopup(sIndex, pIndex, nodeIndex)"
                                v-on:clickout="closeSidePopup(sIndex, pIndex, nodeIndex)">
                                <i class="fa fa-ellipsis-v"></i>
                              </span>
                            </div>
                            <div class="plan-side-popup" v-if="
                              showSidePopup[sIndex] &&
                              showSidePopup[sIndex][pIndex] &&
                              showSidePopup[sIndex][pIndex][nodeIndex]
                            ">
                              <!-- <div @click.prevent="
                                openModal(
                                  visit,
                                  patient.subjectId,
                                  site.siteCode,
                                  visit.visitStatus
                                )
                                ">
                                {{ $t("navigations.new form") }}
                              </div> -->
                              <div v-if="roleprivileges.includes('Subject Schedule Assign ePRO Form')"
                                @click.prevent="openAssignFormModal(patient.patientId, node.visit.visitName, node.visit.visitNo, node.visit.__visitIndex, node.visit.sheduleId, site.siteCode, node.visit.patientNo)">
                                {{ $t("navigations.assign ePRO form") }}
                              </div>
                                    <div v-if="roleprivileges.includes('Subject Schedule Video Call')" @click.prevent="openVideoCallSchedulePopup(patient.patientId)">
                                      Video Call
                                    </div>
                              <div 
                                v-if="hasNextSortedVisit(patient.patientId, node.visit) && roleprivileges.includes('Subject Schedule Plan Next Visit')"
                                @click.prevent="openPlanNextVisitModal(patient.patientId, pIndex, node.visit)" >
                                Plan Next Visit
                              </div>
                              <div @click.prevent="openManageVisitPopup(node.visit, pIndex)" v-if="roleprivileges.includes('Subject Schedule Change Visit Date')">
                                Change Visit Date
                              </div>
                              <div @click.prevent="openchangeplanneddatePopup(node.visit)" v-if="roleprivileges.includes('Subject Schedule Change Planned Date')">
                                Change Planned Date
                              </div>
                               <div @click.prevent="openManageVisitPopupNew(node.visit)" v-if="roleprivileges.includes('Subject Schedule Manage Visit')">
                               Manage Visit
                              </div>
                                 <div @click.prevent="openUnscheduledVisitModal(node.visit)" v-if="roleprivileges.includes('Subject Schedule Add Unscheduled Visit')">
                              Add Unscheduled Visit
                              </div>
                              <div v-if="node.visit.visitStatus != 'Completed' && roleprivileges.includes('Subject Schedule Change Visit Status')" @click.prevent="
                                openChangeStatusmodal(
                                  node.visit.studyId,
                                  node.visit.visitNo,
                                  patient.patientId,
                                  node.visit.visitStatus,
                                  node.visit.__visitIndex,
                                  'Visit'
                                )
                                ">
                                {{ $t("navigations.change status") }}
                              </div>
                            </div>
                            <ul>
                              <li v-if="observationValue[node.visit.visitNo+patient.patientId]==true">
                                <input type="checkbox">
                                <label
                                  @click.prevent="toggleObservationFolder(node.visit.siteCode,node.visit.patientNo,node.visit.visitName,node.visit.visitNo,patient.patientId)"
                                  class="tree_label">{{ $t("navigations.observations") }}</label>

                                <template v-if="categoryFlags[node.visit.visitNo + patient.patientId]">
                                  <div v-for="docType in categoryFlags[node.visit.visitNo + patient.patientId]"
                                    :key="docType.id" class="tree-node mb-2">
                                    <div @click.prevent="docType.flag = !docType.flag">
                                      <span class="cursor-pointer">
                                        <i class="fa fa-file-code-o text-primary me-2"></i>
                                        {{ docType.category }}
                                      </span>
                                    </div>
                                    <div class="row" v-if="docType.flag == true">
                                      <div class="d-flex pt-2 pl-4 cursor-pointer"
                                        v-for="(value, index) in docType.code" :key="index"
                                        @click.prevent="selectDocument(site.siteCode,patient.subjectId,docType.document[index],visit.visitName,patient.patientId,patient.siteId)">
                                        <span class="mr-1">{{ value }}</span>
                                        <span v-if="docType.effectiveDateTime[index]">
                                          ({{ filterTimeFormat(docType.effectiveDateTime[index]) }})
                                        </span>
                                      </div>
                                    </div>


                                  </div>
                                </template>


                              </li>
                            </ul>
                            <template v-if="(activityobject?.[`${node.visit.visitNo}_${patient.patientId}`]?.[node.visit.__visitIndex] || []).length">

                              <ul
                                v-for="(singleactivity, activityindex) in (activityobject?.[`${node.visit.visitNo}_${patient.patientId}`]?.[node.visit.__visitIndex] || [])"
                                :key="singleactivity.activityId">
                                <li>
                                  <input v-if="singleactivity.activityId"
                                    :id="activityInputId(singleactivity, patient, node.visit)" type="checkbox" @change="
                                      getFormsByVisit(
                                        patient.patientId,
                                        node.visit.visitNo,
                                        node.visit.visitName,
                                        node.visit.__visitIndex,
                                        node.visit.sheduleId,
                                        activityindex,
                                        singleactivity.activityId,
                                        singleactivity.activityOrder
                                      )
                                      " />
                                  <label class="tree_label" :for="activityInputId(singleactivity, patient, node.visit)"
                                    @click.stop>

                                    <div>

                                      <span>

                                        {{ singleactivity.activityName }}
                                        <span class="badge custom-form-tooltip-wrapper"
                                          :style="`background-color: ${singleactivity.statusHex}; color: black;`">
                                          {{ singleactivity.status }}</span>
                                      </span>
                                      <button v-if="singleactivity.formStatus !== 'Completed' &&
                                        (roleprivileges.includes('Subject Schedule Change Activity Status') ||
                                          roleprivileges.includes('Subject Schedule Add New Form'))"
                                        :popovertarget="popoverId(singleactivity.activityId, sIndex, pIndex, node.visit.__visitIndex)"
                                        :style="popoverTriggerStyle(singleactivity.activityId, sIndex, pIndex, node.visit.__visitIndex)"
                                        class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                        <i class="fa fa-ellipsis-v"></i>
                                      </button>
                                      <div
                                        v-if="roleprivileges.includes('Subject Schedule Change Activity Status') || roleprivileges.includes('Subject Schedule Add New Form')"
                                        :id="popoverId(singleactivity.activityId, sIndex, pIndex, node.visit.__visitIndex)"
                                        popover class="visit-popup-menu"
                                        :style="popoverMenuStyle(singleactivity.activityId, sIndex, pIndex, node.visit.__visitIndex)">
                                        <button @click.prevent.stop="
                                          openChangeStatusmodalforactivity(
                                            singleactivity.actScheduleId,
                                            singleactivity.status,
                                            patient.patientId,
                                            node.visit.visitNo,
                                            node.visit.visitName,
                                            node.visit.__visitIndex,
                                            node.visit.sheduleId,
                                            popoverId(singleactivity.activityId, sIndex, pIndex, node.visit.__visitIndex),
                                          )
                                          " class="popup-menu-block text-left w-100">
                                          {{ $t("navigations.change status") }}
                                        </button>
                                        <button  v-if="roleprivileges.includes('Subject Schedule Add New Form')"
                                        @click.prevent="
                                          openModal(
                                            {
                                              visitNo: node.visit.visitNo,
                                              visitName: node.visit.visitName,
                                              sheduleId: node.visit.sheduleId,
                                              studyId: node.visit.studyId,
                                               visitId: singleactivity.visitId,
                                                actScheduleId: singleactivity.actScheduleId,
                                                subjectId: singleactivity.subjectId,
                                              activityId: singleactivity.activityId,
                                              activityName: singleactivity.activityName,
                                              siteId: site.siteID 
                                            },
                                            patient.subjectId,
                                            site.siteCode,
                                            singleactivity.status,
                                             popoverId(singleactivity.activityId, sIndex, pIndex, node.visit.__visitIndex),site.siteID  
                                             
                                          )
                                          " class="popup-menu-block text-left w-100">
                                          {{ $t('navigations.new form') }}
                                        </button>

                                      </div>

                                    </div>
                                  </label>
                                  <template v-if="visitFormObj[node.visit.visitNo + patient.patientId]">
                                    <ul>
                                      <li v-for="singlevisit in visitFormObj[
                                        node.visit.visitNo + patient.patientId
                                      ][activityindex]" :key="singlevisit.sheduleId">

                                        <input v-if="singlevisit.templateName" type="checkbox"
                                          :id="formInputId(singlevisit, pIndex, node.visit.__visitIndex, activityindex)" @click.prevent="
                                          gotoform(singlevisit, patient.subjectId, site.siteCode)
                                          " />
                                        <label class="tree_label"
                                          :for="formInputId(singlevisit, pIndex, node.visit.__visitIndex, activityindex)" @click.stop>
                                          <div class="d-flex">

                                            <div class="d-flex align-items-center">
                                              <p class="mb-0" style="max-width: 28ch;">
                                                {{
                                                  singlevisit.formStatus === 'Completed'
                                                  ? singlevisit.templateName + ' (' + singlevisit.version + ') - ' + singlevisit.languageCode?.toUpperCase() +
                                                  ' - ' +
                                                  (singlevisit.visitCompletedDate
                                                  ? filter(singlevisit.visitCompletedDate) + '-'
                                                  : '')
                                                  : singlevisit.templateName + ' (' + singlevisit.version + ') - ' + singlevisit.languageCode?.toUpperCase()
                                                }}</p>
                                              <span class="badge custom-form-tooltip-wrapper"
                                                @mouseenter="showPopover(`formStatus-${singlevisit.sheduleId}-${pIndex}-${node.visit.__visitIndex}`)"
                                                @mouseleave="hidePopover(`formStatus-${singlevisit.sheduleId}-${pIndex}-${node.visit.__visitIndex}`)"
                                                :popovertarget="`formStatus-${singlevisit.sheduleId}-${pIndex}-${node.visit.__visitIndex}`"
                                                :style="`background-color: ${singlevisit.formStatusHex}; color: black; anchor-name:--formStatus-${singlevisit.sheduleId}-${pIndex}-${node.visit.__visitIndex};`">
                                                {{ singlevisit.formStatus }}</span>
                                              <span v-if="singlevisit.formStatusDescription" popover
                                                class="custom-form-tooltip-text"
                                                :id="`formStatus-${singlevisit.sheduleId}-${pIndex}-${node.visit.__visitIndex}`"
                                                :style="`position-anchor:--formStatus-${singlevisit.sheduleId}-${pIndex}-${node.visit.__visitIndex};`">
                                                {{ singlevisit.formStatusDescription }}</span>
                                            </div>


                                            <button v-if="(singlevisit.formStatus !== 'Completed') ||
                                              roleprivileges.includes('Subject Schedule Change Form Status') ||
                                              (singlevisit.formStatus == 'Completed' && singlevisit.sdvAssigned == false && singlevisit.isSdv == true)"
                                              :popovertarget="popoverId(singlevisit.sheduleId, sIndex, pIndex, node.visit.__visitIndex)"
                                              :style="popoverTriggerStyle(singlevisit.sheduleId, sIndex, pIndex, node.visit.__visitIndex)"
                                              class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                              <i class="fa fa-ellipsis-v"></i>
                                            </button>
                                            <div v-if="(singlevisit.formStatus !== 'Completed') ||
                                              roleprivileges.includes('Subject Schedule Change Form Status') ||
                                              (singlevisit.formStatus == 'Completed' && singlevisit.sdvAssigned == false && singlevisit.isSdv == true)"
                                              :id="popoverId(singlevisit.sheduleId, sIndex, pIndex, node.visit.__visitIndex)"
                                              popover class="visit-popup-menu"
                                              :style="popoverMenuStyle(singlevisit.sheduleId, sIndex, pIndex, node.visit.__visitIndex)">
                                              <button v-if="singlevisit.formStatus !== 'Completed' && roleprivileges.includes('Subject Schedule Change Form Status')" @click.prevent.stop="
                                                openChangeStatusmodal(
                                                  node.visit.studyId,
                                                  node.visit.visitNo,
                                                  patient.patientId,
                                                  node.visit.visitStatus,
                                                  node.visit.__visitIndex,
                                                  'Form',
                                                  popoverId(singlevisit.sheduleId, sIndex, pIndex, node.visit.__visitIndex),
                                                  node.visit.visitName,
                                                  singlevisit.formStatus,
                                                  singlevisit.formId,
                                                  singlevisit.sheduleId
                                                )
                                                " class="popup-menu-block text-left w-100">
                                                {{ $t("navigations.change status") }}
                                              </button>
                                              <button
                                                v-if="roleprivileges.includes('Subject Schedule Change Form Status') && singlevisit.formStatus !== 'Completed'"
                                                @click.prevent="
                                                  ChangeTemplatePopup(
                                                    node.visit.studyId,
                                                    node.visit.visitNo,
                                                    patient.patientId,
                                                    node.visit.visitStatus,
                                                    node.visit.__visitIndex,
                                                    'Form',
                                                    popoverId(singlevisit.sheduleId, sIndex, pIndex, node.visit.__visitIndex),
                                                    node.visit.visitName,
                                                    singlevisit.formStatus,
                                                    singlevisit.sheduleId,
                                                    singlevisit.templateId
                                                  )
                                                  " class="popup-menu-block text-left w-100">
                                                {{ $t("navigations.change ecrf") }}
                                              </button>
                                              <button
                                                v-if="singlevisit.formStatus == 'Completed' && singlevisit.sdvAssigned == false && singlevisit.isSdv == true"
                                                @click.prevent.stop="
                                                assignSdv(                                                
                                                  singlevisit.formId,
                                                  singlevisit.templateId,
                                                  popoverId(singlevisit.sheduleId, sIndex, pIndex, node.visit.__visitIndex),
                                                )
                                                " class="popup-menu-block text-left w-100">
                                                {{ $t("navigations.assign sdv") }}
                                              </button>
                                            </div>
                                          </div>
                                        </label>
                                      </li>
                                    </ul>
                                  </template>
                                </li>
                              </ul>
                            </template>
                          </template>
                          <template v-else-if="node && (node.type === 'cycle' || node.type === 'studyPhase')">
                            <input
                              type="checkbox"
                              :id="`${node.type}-${patient.patientId}-${nodeIndex}`"
                            />

                            <div class="tree-row">
                              <label class="tree_label" :for="`${node.type}-${patient.patientId}-${nodeIndex}`">
                                {{ node.displayText }}
                              </label>
                              <span
                                v-if="node.type === 'cycle'"
                                class="tree-actions position-relative cursor-pointer px-2"
                                @click.prevent="toggleCycleSidePopup(sIndex, pIndex, nodeIndex)"
                                v-on:clickout="closeCycleSidePopup(sIndex, pIndex, nodeIndex)"
                              >
                                <i class="fa fa-ellipsis-v"></i>
                              </span>
                            </div>

                            <div
                              v-if="
                                node.type === 'cycle' &&
                                showCycleSidePopup[sIndex] &&
                                showCycleSidePopup[sIndex][pIndex] &&
                                showCycleSidePopup[sIndex][pIndex][nodeIndex]
                              "
                              class="plan-side-popup"
                            >
                              <div @click.prevent="openScheduleCyclePopup(node.cycleId, patient.patientId, pIndex)">
                                Repeat Cycle
                              </div>
                              <div @click.prevent="openManageCyclePopup(node.cycleId, patient.patientId, pIndex, node.occurence)">
                                Manage Cycle
                              </div>
                              <div @click.prevent="openCycleStatusUpdatePopup(node.cycleId, node.occurence, patient.patientId, pIndex)">
                                Update Cycle Status
                              </div>
                            </div>

                            <!-- ================= VISITS INSIDE FOLDER ================= -->
                            <ul>
                              <li
                                v-for="(visit, visitIndex) in node.visits"
                                :key="
                                  visit && visit.type === 'cycle'
                                    ? `cycle-${patient.patientId}-${getNestedNodeIndex(nodeIndex, visitIndex)}`
                                    : visit.sheduleId
                                "
                              >
                                <template v-if="visit && visit.type === 'cycle'">
                                  <input
                                    type="checkbox"
                                    :id="`cycle-${patient.patientId}-${getNestedNodeIndex(nodeIndex, visitIndex)}`"
                                  />

                                  <div class="tree-row">
                                    <label
                                      class="tree_label"
                                      :for="`cycle-${patient.patientId}-${getNestedNodeIndex(nodeIndex, visitIndex)}`"
                                    >
                                      {{ visit.displayText }}
                                    </label>
                                    <span
                                      class="tree-actions position-relative cursor-pointer px-2"
                                      @click.prevent="
                                        toggleCycleSidePopup(
                                          sIndex,
                                          pIndex,
                                          getNestedNodeIndex(nodeIndex, visitIndex)
                                        )
                                      "
                                      v-on:clickout="
                                        closeCycleSidePopup(
                                          sIndex,
                                          pIndex,
                                          getNestedNodeIndex(nodeIndex, visitIndex)
                                        )
                                      "
                                    >
                                      <i class="fa fa-ellipsis-v"></i>
                                    </span>
                                  </div>

                                  <div
                                    v-if="
                                      showCycleSidePopup[sIndex] &&
                                      showCycleSidePopup[sIndex][pIndex] &&
                                      showCycleSidePopup[sIndex][pIndex][getNestedNodeIndex(nodeIndex, visitIndex)]
                                    "
                                    class="plan-side-popup"
                                  >
                                    <div @click.prevent="openScheduleCyclePopup(visit.cycleId, patient.patientId, pIndex)">
                                      Repeat Cycle
                                    </div>
                                    <div
                                      @click.prevent="
                                        openManageCyclePopup(
                                          visit.cycleId,
                                          patient.patientId,
                                          pIndex,
                                          visit.occurence
                                        )
                                      "
                                    >
                                      Manage Cycle
                                    </div>
                                    <div
                                      @click.prevent="
                                        openCycleStatusUpdatePopup(
                                          visit.cycleId,
                                          visit.occurence,
                                          patient.patientId,
                                          pIndex
                                        )
                                      "
                                    >
                                      Update Cycle Status
                                    </div>
                                  </div>

                                  <ul>
                                    <li v-for="cycleVisit in visit.visits" :key="cycleVisit.sheduleId">
                                      <input
                                        type="checkbox"
                                        :id="cycleVisit.sheduleId + patient.patientId"
                                        @change="
                                          getactivities(
                                            patient.patientId,
                                            cycleVisit.visitNo,
                                            cycleVisit.visitName,
                                            cycleVisit.__visitIndex,
                                            cycleVisit.sheduleId,
                                            site.siteCode,
                                            cycleVisit.patientNo
                                          )
                                        "
                                      />

                                      <div class="tree-row">
                                        <label
                                          :for="cycleVisit.sheduleId + patient.patientId"
                                          class="tree_label"
                                        >
                                          {{ cycleVisit.visitNo }} - {{ cycleVisit.visitName }} - ( {{ setdate(cycleVisit) }} )
                                          <span
                                            class="badge custom-tooltip-wrapper"
                                            :style="`background-color: ${cycleVisit.visitStatusHex}; color: black;`"
                                          >
                                            {{ cycleVisit.visitStatus }}
                                          </span>
                                        </label>

                                        <span v-if="roleprivileges.includes('Subject Schedule Assign ePRO Form') ||
                                          roleprivileges.includes('Subject Schedule Video Call') ||
                                          roleprivileges.includes('Subject Schedule Plan Next Visit') ||
                                          roleprivileges.includes('Subject Schedule Change Visit Date') ||
                                          roleprivileges.includes('Subject Schedule Change Planned Date') ||
                                          roleprivileges.includes('Subject Schedule Manage Visit') ||
                                          roleprivileges.includes('Subject Schedule Add Unscheduled Visit') ||
                                          roleprivileges.includes('Subject Schedule Change Visit Status')"
                                          class="tree-actions position-relative cursor-pointer px-2"
                                          @click.prevent="toggleSidePopup(sIndex, pIndex, cycleVisit.__visitIndex)"
                                          v-on:clickout="closeSidePopup(sIndex, pIndex, cycleVisit.__visitIndex)">
                                          <i class="fa fa-ellipsis-v"></i>
                                        </span>
                                      </div>

                                      <div
                                        class="plan-side-popup"
                                        v-if="
                                          showSidePopup[sIndex] &&
                                          showSidePopup[sIndex][pIndex] &&
                                          showSidePopup[sIndex][pIndex][cycleVisit.__visitIndex]
                                        "
                                      >
                                        <div
                                          v-if="roleprivileges.includes('Subject Schedule Assign ePRO Form')"
                                          @click.prevent="
                                            openAssignFormModal(
                                              patient.patientId,
                                              cycleVisit.visitName,
                                              cycleVisit.visitNo,
                                              cycleVisit.__visitIndex,
                                              cycleVisit.sheduleId,
                                              site.siteCode,
                                              cycleVisit.patientNo
                                            )
                                          "
                                        >
                                          {{ $t('navigations.assign ePRO form') }}
                                        </div>

                                        <div v-if="roleprivileges.includes('Subject Schedule Video Call')" @click.prevent="openVideoCallSchedulePopup(patient.patientId)">
                                          Video Call
                                        </div>
                                        <div
                                          v-if="hasNextSortedVisit(patient.patientId, cycleVisit) && roleprivileges.includes('Subject Schedule Plan Next Visit')"
                                          @click.prevent="openPlanNextVisitModal(patient.patientId, pIndex, cycleVisit)"
                                        >
                                          Plan Next Visit
                                        </div>
                                        <div @click.prevent="openManageVisitPopup(cycleVisit, pIndex)" v-if="roleprivileges.includes('Subject Schedule Change Visit Date')">
                                          Change Visit Date
                                        </div>
                                        <div @click.prevent="openchangeplanneddatePopup(cycleVisit)" v-if="roleprivileges.includes('Subject Schedule Change Planned Date')">
                                          Change planned date
                                        </div>
                                        <div @click.prevent="openManageVisitPopupNew(cycleVisit, pIndex)" v-if="roleprivileges.includes('Subject Schedule Manage Visit')">
                                          Manage Visit
                                        </div>
                                        <div @click.prevent="openUnscheduledVisitModal(cycleVisit, pIndex)" v-if="roleprivileges.includes('Subject Schedule Add Unscheduled Visit')">
                                          Add Unscheduled Visit
                                        </div>

                                        <div v-if="cycleVisit.visitStatus !== 'Completed' && roleprivileges.includes('Subject Schedule Change Visit Status')" 
                                          @click.prevent="
                                            openChangeStatusmodal(
                                              cycleVisit.studyId,
                                              cycleVisit.visitNo,
                                              patient.patientId,
                                              cycleVisit.visitStatus,
                                              cycleVisit.__visitIndex,
                                              'Visit'
                                            )
                                          "
                                        >
                                          {{ $t('navigations.change status') }}
                                        </div>
                                      </div>

                                      <ul>
                                        <li
                                          v-if="
                                            observationValue[cycleVisit.visitNo + patient.patientId] === true
                                          "
                                        >
                                          <input type="checkbox" />

                                          <label
                                            @click.prevent="
                                              toggleObservationFolder(
                                                cycleVisit.siteCode,
                                                cycleVisit.patientNo,
                                                cycleVisit.visitName,
                                                cycleVisit.visitNo,
                                                patient.patientId
                                              )
                                            "
                                            class="tree_label"
                                          >
                                            {{ $t('navigations.observations') }}
                                          </label>

                                          <template
                                            v-if="categoryFlags[cycleVisit.visitNo + patient.patientId]"
                                          >
                                            <div
                                              v-for="docType in categoryFlags[cycleVisit.visitNo + patient.patientId]"
                                              :key="docType.id"
                                              class="tree-node mb-2"
                                            >
                                              <div @click.prevent="docType.flag = !docType.flag">
                                                <span class="cursor-pointer">
                                                  <i class="fa fa-file-code-o text-primary me-2"></i>
                                                  {{ docType.category }}
                                                </span>
                                              </div>

                                              <div class="row" v-if="docType.flag === true">
                                                <div
                                                  class="d-flex pt-2 pl-4 cursor-pointer"
                                                  v-for="(value, index) in docType.code"
                                                  :key="index"
                                                  @click.prevent="
                                                    selectDocument(
                                                      site.siteCode,
                                                      patient.subjectId,
                                                      docType.document[index],
                                                      cycleVisit.visitName,
                                                      patient.patientId,
                                                      patient.siteId
                                                    )
                                                  "
                                                >
                                                  <span class="mr-1">{{ value }}</span>
                                                  <span v-if="docType.effectiveDateTime[index]">
                                                    ({{ filterTimeFormat(docType.effectiveDateTime[index]) }})
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </template>
                                        </li>
                                      </ul>

                                      <template
                                        v-if="
                                          (activityobject?.[`${cycleVisit.visitNo}_${patient.patientId}`]?.[
                                            cycleVisit.__visitIndex
                                          ] || []).length
                                        "
                                      >
                                        <ul>
                                          <li
                                            v-for="(singleactivity, activityindex) in
                                              (activityobject?.[
                                                `${cycleVisit.visitNo}_${patient.patientId}`
                                              ]?.[cycleVisit.__visitIndex] || [])"
                                            :key="singleactivity.activityId"
                                          >
                                            <input
                                              v-if="singleactivity.activityId"
                                              :id="activityInputId(singleactivity, patient, cycleVisit)"
                                              type="checkbox"
                                              @change="
                                                getFormsByVisit(
                                                  patient.patientId,
                                                  cycleVisit.visitNo,
                                                  cycleVisit.visitName,
                                                  cycleVisit.__visitIndex,
                                                  cycleVisit.sheduleId,
                                                  activityindex,
                                                  singleactivity.activityId,
                                                  singleactivity.activityOrder
                                                )
                                              "
                                            />

                                            <label
                                              class="tree_label"
                                              :for="activityInputId(singleactivity, patient, cycleVisit)"
                                              @click.stop
                                            >
                                              <div>
                                                <span>
                                                  {{ singleactivity.activityName }}
                                                  <span
                                                    class="badge custom-form-tooltip-wrapper"
                                                    :style="`background-color: ${singleactivity.statusHex}; color: black;`"
                                                  >
                                                    {{ singleactivity.status }}
                                                  </span>
                                                </span>
                                               <button v-if="singleactivity.formStatus !== 'Completed' &&
                                                  (roleprivileges.includes('Subject Schedule Change Activity Status') ||
                                                    roleprivileges.includes('Subject Schedule Add New Form'))"
                                                  :popovertarget="popoverId(singleactivity.activityId, sIndex, pIndex, cycleVisit.__visitIndex)"
                                                  :style="popoverTriggerStyle(singleactivity.activityId, sIndex, pIndex, cycleVisit.__visitIndex)"
                                                  class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                                  <i class="fa fa-ellipsis-v"></i>
                                                </button>
                                                <div
                                                  v-if="roleprivileges.includes('Subject Schedule Change Activity Status') || roleprivileges.includes('Subject Schedule Add New Form')"
                                                  :id="popoverId(singleactivity.activityId, sIndex, pIndex, cycleVisit.__visitIndex)"
                                                  popover class="visit-popup-menu"
                                                  :style="popoverMenuStyle(singleactivity.activityId, sIndex, pIndex, cycleVisit.__visitIndex)"
>
                                                  <button
                                                    @click.prevent.stop="
                                                      openChangeStatusmodalforactivity(
                                                        singleactivity.actScheduleId,
                                                        singleactivity.status,
                                                        patient.patientId,
                                                        cycleVisit.visitNo,
                                                        cycleVisit.visitName,
                                                        cycleVisit.__visitIndex,
                                                        cycleVisit.sheduleId,
                                                        popoverId(
                                                          singleactivity.activityId,
                                                          sIndex,
                                                          pIndex,
                                                          cycleVisit.__visitIndex
                                                        ),
                                                      )
                                                    "
                                                    class="popup-menu-block text-left w-100"
                                                  >
                                                    {{ $t('navigations.change status') }}
                                                  </button>
                                                  <button  v-if="roleprivileges.includes('Subject Schedule Add New Form')"
                                                    @click.prevent="
                                                      openModal(
                                                        {
                                                          visitNo: cycleVisit.visitNo,
                                                          visitName: cycleVisit.visitName,
                                                          sheduleId: cycleVisit.sheduleId,
                                                          studyId: cycleVisit.studyId,
                                                          visitId: singleactivity.visitId,
                                                          actScheduleId: singleactivity.actScheduleId,
                                                          subjectId: singleactivity.subjectId,
                                                          activityId: singleactivity.activityId,
                                                          activityName: singleactivity.activityName,
                                                          siteId: site.siteID
                                                        },
                                                        patient.subjectId,
                                                        site.siteCode,
                                                        singleactivity.status,
                                                        popoverId(
                                                          singleactivity.activityId,
                                                          sIndex,
                                                          pIndex,
                                                          cycleVisit.__visitIndex
                                                        ),
                                                        site.siteID
                                                      )
                                                    "
                                                    class="popup-menu-block text-left w-100"
                                                  >
                                                    {{ $t('navigations.new form') }}
                                                  </button>
                                                </div>
                                              </div>
                                            </label>
                                            <template v-if="visitFormObj[cycleVisit.visitNo + patient.patientId]">
                                              <ul>
                                                <li
                                                  v-for="singlevisit in visitFormObj[
                                                    cycleVisit.visitNo + patient.patientId
                                                  ][activityindex]"
                                                  :key="singlevisit.sheduleId"
                                                >
                                                  <input
                                                    v-if="singlevisit.templateName"
                                                    type="checkbox"
                                                    :id="
                                                      formInputId(
                                                        singlevisit,
                                                        pIndex,
                                                        cycleVisit.__visitIndex,
                                                        activityindex
                                                      )
                                                    "
                                                    @click.prevent="
                                                      gotoform(singlevisit, patient.subjectId, site.siteCode)
                                                    "
                                                  />

                                                  <label
                                                    class="tree_label"
                                                    :for="
                                                      formInputId(
                                                        singlevisit,
                                                        pIndex,
                                                        cycleVisit.__visitIndex,
                                                        activityindex
                                                      )
                                                    "
                                                    @click.stop
                                                  >
                                                    <div class="d-flex">
                                                      <div class="d-flex align-items-center">
                                                        <p class="mb-0" style="max-width: 28ch;">
                                                          {{
                                                            singlevisit.formStatus === 'Completed'
                                                              ? singlevisit.templateName +
                                                                ' - ' +
                                                                (singlevisit.visitCompletedDate
                                                                  ? filter(singlevisit.visitCompletedDate) + '-'
                                                                  : '')
                                                              : singlevisit.templateName
                                                          }}
                                                        </p>

                                                        <span
                                                          class="badge custom-form-tooltip-wrapper"
                                                          @mouseenter="
                                                            showPopover(
                                                              `formStatus-${singlevisit.sheduleId}-${pIndex}-${cycleVisit.__visitIndex}`
                                                            )
                                                          "
                                                          @mouseleave="
                                                            hidePopover(
                                                              `formStatus-${singlevisit.sheduleId}-${pIndex}-${cycleVisit.__visitIndex}`
                                                            )
                                                          "
                                                          :popovertarget="
                                                            `formStatus-${singlevisit.sheduleId}-${pIndex}-${cycleVisit.__visitIndex}`
                                                          "
                                                          :style="`background-color: ${singlevisit.formStatusHex}; color: black;`"
                                                        >
                                                          {{ singlevisit.formStatus }}
                                                        </span>

                                                        <span
                                                          v-if="singlevisit.formStatusDescription"
                                                          popover
                                                          class="custom-form-tooltip-text"
                                                          :id="
                                                            `formStatus-${singlevisit.sheduleId}-${pIndex}-${cycleVisit.__visitIndex}`
                                                          "
                                                        >
                                                          {{ singlevisit.formStatusDescription }}
                                                        </span>
                                                      </div>

                                                      <button
                                                        :popovertarget="
                                                          popoverId(
                                                            singlevisit.sheduleId,
                                                            sIndex,
                                                            pIndex,
                                                            cycleVisit.__visitIndex
                                                          )
                                                        "
                                                        :style="popoverTriggerStyle(
                                                          singlevisit.sheduleId,
                                                          sIndex,
                                                          pIndex,
                                                          cycleVisit.__visitIndex
                                                        )"
                                                        class="visit-ellipsis-btn py-0 px-3"
                                                        @click.stop
                                                      >
                                                        <i class="fa fa-ellipsis-v"></i>
                                                      </button>

                                                      <div
                                                        :id="
                                                          popoverId(
                                                            singlevisit.sheduleId,
                                                            sIndex,
                                                            pIndex,
                                                            cycleVisit.__visitIndex
                                                          )
                                                        "
                                                        popover
                                                        class="visit-popup-menu"
                                                        :style="popoverMenuStyle(
                                                          singlevisit.sheduleId,
                                                          sIndex,
                                                          pIndex,
                                                          cycleVisit.__visitIndex
                                                        )"
                                                      >
                                                        <button
                                                          v-if="singlevisit.formStatus !== 'Completed' && roleprivileges.includes('Subject Schedule Change Form Status')"
                                                          @click.prevent.stop="
                                                            openChangeStatusmodal(
                                                              cycleVisit.studyId,
                                                              cycleVisit.visitNo,
                                                              patient.patientId,
                                                              cycleVisit.visitStatus,
                                                              cycleVisit.__visitIndex,
                                                              'Form',
                                                              popoverId(
                                                                singlevisit.sheduleId,
                                                                sIndex,
                                                                pIndex,
                                                                cycleVisit.__visitIndex
                                                              ),
                                                              cycleVisit.visitName,
                                                              singlevisit.formStatus,
                                                              singlevisit.formId,
                                                              singlevisit.sheduleId
                                                            )
                                                          "
                                                          class="popup-menu-block text-left w-100"
                                                        >
                                                          {{ $t('navigations.change status') }}
                                                        </button>
                                                        <button
                                                          v-if="
                                                            singlevisit.formStatus == 'Completed' &&
                                                            singlevisit.sdvAssigned == false &&
                                                            singlevisit.isSdv == true
                                                          "
                                                          @click.prevent.stop="
                                                            assignSdv(
                                                              singlevisit.formId,
                                                              singlevisit.templateId,
                                                              popoverId(
                                                                singlevisit.sheduleId,
                                                                sIndex,
                                                                pIndex,
                                                                cycleVisit.__visitIndex
                                                              )
                                                            )
                                                          "
                                                          class="popup-menu-block text-left w-100"
                                                        >
                                                          {{ $t('navigations.assign sdv') }}
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </label>
                                                </li>
                                              </ul>
                                            </template>
                                          </li>
                                        </ul>
                                      </template>
                                    </li>
                                  </ul>
                                </template>
                                <template v-else>
                                <!-- VISIT CHECKBOX -->
                                <!-- <input
                                  type="checkbox"
                                  :id="`cycle-visit-${visit.sheduleId}-${patient.patientId}`"
                                  
                                /> -->
                                <input
                                  type="checkbox"
                                  :id="visit.sheduleId + patient.patientId"
                                  @change="
                                    getactivities(
                                      patient.patientId,
                                      visit.visitNo,
                                      visit.visitName,
                                      visit.__visitIndex,
                                      visit.sheduleId,
                                      site.siteCode,
                                      visit.patientNo
                                    )
                                  "
                                />

                                <div class="tree-row">
                                  <label
                                    :for="visit.sheduleId + patient.patientId"
                                    class="tree_label"
                                  >
                                    {{ visit.visitNo }} - {{ visit.visitName }} - ( {{ setdate(visit) }} )
                                    <span
                                      class="badge custom-tooltip-wrapper"
                                      :style="`background-color: ${visit.visitStatusHex}; color: black;`"
                                    >
                                      {{ visit.visitStatus }}
                                    </span>
                                  </label>


                                <!-- VISIT LABEL -->
                                <!-- <label
                                  :for="`cycle-visit-${visit.sheduleId}-${patient.patientId}`"
                                  class="tree_label"
                                >
                                  {{ visit.visitNo }} - {{ visit.visitName }} -
                                  <span
                                    class="badge custom-tooltip-wrapper"
                                    :style="`background-color: ${visit.visitStatusHex}; color: black;`"
                                  >
                                    {{ visit.visitStatus }}
                                  </span>
                                </label>  -->

                                <!-- ========= OPTIONAL: SIDE MENU ========= -->
                                   <span v-if="roleprivileges.includes('Subject Schedule Assign ePRO Form') ||
                                      roleprivileges.includes('Subject Schedule Video Call') ||
                                      roleprivileges.includes('Subject Schedule Plan Next Visit') ||
                                      roleprivileges.includes('Subject Schedule Change Visit Date') ||
                                      roleprivileges.includes('Subject Schedule Change Planned Date') ||
                                      roleprivileges.includes('Subject Schedule Manage Visit') ||
                                      roleprivileges.includes('Subject Schedule Add Unscheduled Visit') ||
                                      roleprivileges.includes('Subject Schedule Change Visit Status')"
                                      class="tree-actions position-relative cursor-pointer px-2"
                                      @click.prevent="toggleSidePopup(sIndex, pIndex, visit.__visitIndex)"
                                      v-on:clickout="closeSidePopup(sIndex, pIndex, visit.__visitIndex)">
                                      <i class="fa fa-ellipsis-v"></i>
                                    </span>

                                </div>

                                <div
                                  class="plan-side-popup"
                                  v-if="
                                    showSidePopup[sIndex] &&
                                    showSidePopup[sIndex][pIndex] &&
                                    showSidePopup[sIndex][pIndex][visit.__visitIndex]
                                  "
                                >
                                  <div v-if="roleprivileges.includes('Subject Schedule Assign ePRO Form')"
                                    @click.prevent="
                                      openAssignFormModal(
                                        patient.patientId,
                                        visit.visitName,
                                        visit.visitNo,
                                        visit.__visitIndex,
                                        visit.sheduleId,
                                        site.siteCode,
                                        visit.patientNo
                                      )
                                    "
                                  >
                                    {{ $t('navigations.assign ePRO form') }}
                                  </div>

                                  <div v-if="roleprivileges.includes('Subject Schedule Video Call')" @click.prevent="openVideoCallSchedulePopup(patient.patientId)">
                                    Video Call
                                  </div>
                                  <div
                                    v-if="hasNextSortedVisit(patient.patientId, visit) && roleprivileges.includes('Subject Schedule Plan Next Visit')"
                                    @click.prevent="openPlanNextVisitModal(patient.patientId, pIndex, visit)">
                                    Plan Next Visit
                                  </div>
                                  <div @click.prevent="openManageVisitPopup(visit, pIndex)" v-if="roleprivileges.includes('Subject Schedule Change Visit Date')">
                                    Change Visit Date
                                  </div>
                                  <div @click.prevent="openchangeplanneddatePopup(visit)" v-if="roleprivileges.includes('Subject Schedule Change Planned Date')">
                                    Change planned date
                                  </div>
                                  <div @click.prevent="openManageVisitPopupNew(visit, pIndex)" v-if="roleprivileges.includes('Subject Schedule Manage Visit')">
                                   Manage Visit
                                  </div>
                                   <div @click.prevent="openUnscheduledVisitModal(visit, pIndex)" v-if="roleprivileges.includes('Subject Schedule Add Unscheduled Visit')">
                                  Add Unscheduled Visit
                                  </div>
                                

                                  <div
                                    v-if="visit.visitStatus !== 'Completed' && roleprivileges.includes('Subject Schedule Change Visit Status') " 
                                    @click.prevent="
                                      openChangeStatusmodal(
                                        visit.studyId,
                                        visit.visitNo,
                                        patient.patientId,
                                        visit.visitStatus,
                                        visit.__visitIndex,
                                        'Visit'
                                      )
                                    "
                                  >
                                    {{ $t('navigations.change status') }}
                                  </div>
                                </div>
                                <ul>
                                  <li v-if="observationValue[visit.visitNo + patient.patientId] === true">
                                    <input type="checkbox" />

                                    <label
                                      @click.prevent="
                                        toggleObservationFolder(
                                          visit.siteCode,
                                          visit.patientNo,
                                          visit.visitName,
                                          visit.visitNo,
                                          patient.patientId
                                        )
                                      "
                                      class="tree_label"
                                    >
                                      {{ $t("navigations.observations") }}
                                    </label>

                                    <template v-if="categoryFlags[visit.visitNo + patient.patientId]">
                                      <div
                                        v-for="docType in categoryFlags[visit.visitNo + patient.patientId]"
                                        :key="docType.id"
                                        class="tree-node mb-2"
                                      >
                                        <div @click.prevent="docType.flag = !docType.flag">
                                          <span class="cursor-pointer">
                                            <i class="fa fa-file-code-o text-primary me-2"></i>
                                            {{ docType.category }}
                                          </span>
                                        </div>

                                        <div class="row" v-if="docType.flag === true">
                                          <div
                                            class="d-flex pt-2 pl-4 cursor-pointer"
                                            v-for="(value, index) in docType.code"
                                            :key="index"
                                            @click.prevent="
                                              selectDocument(
                                                site.siteCode,
                                                patient.subjectId,
                                                docType.document[index],
                                                visit.visitName,
                                                patient.patientId,
                                                patient.siteId
                                              )
                                            "
                                          >
                                            <span class="mr-1">{{ value }}</span>
                                            <span v-if="docType.effectiveDateTime[index]">
                                              ({{ filterTimeFormat(docType.effectiveDateTime[index]) }})
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                  </li>
                                </ul>
                                <!-- ================= ACTIVITIES (CYCLE VISIT) ================= -->
                                <template
                                  v-if="(activityobject?.[`${visit.visitNo}_${patient.patientId}`]?.[visit.__visitIndex] || []).length"
                                >
                                  <ul>
                                    <li
                                      v-for="(singleactivity, activityindex) in
                                        (activityobject?.[`${visit.visitNo}_${patient.patientId}`]?.[visit.__visitIndex] || [])"
                                      :key="singleactivity.activityId"
                                    >
                                      <input
                                        v-if="singleactivity.activityId"
                                        :id="activityInputId(singleactivity, patient, visit)"
                                        type="checkbox"
                                        @change="
                                          getFormsByVisit(
                                            patient.patientId,
                                            visit.visitNo,
                                            visit.visitName,
                                            visit.__visitIndex,
                                            visit.sheduleId,
                                            activityindex,
                                            singleactivity.activityId,
                                            singleactivity.activityOrder
                                          )
                                        "
                                      />

                                        <label
                                          class="tree_label"
                                          :for="activityInputId(singleactivity, patient, visit)"
                                          @click.stop
                                        >
                                          <div>
                                            <span>
                                              {{ singleactivity.activityName }}
                                              <span
                                                class="badge custom-form-tooltip-wrapper"
                                                :style="`background-color: ${singleactivity.statusHex}; color: black;`"
                                              >
                                                {{ singleactivity.status }}
                                              </span>
                                            </span>
                                           <button v-if="singleactivity.formStatus !== 'Completed' &&
                                              (roleprivileges.includes('Subject Schedule Change Activity Status') ||
                                                roleprivileges.includes('Subject Schedule Add New Form'))"
                                              :popovertarget="popoverId(singleactivity.activityId, sIndex, pIndex, visit.__visitIndex)"
                                              :style="popoverTriggerStyle(singleactivity.activityId, sIndex, pIndex, visit.__visitIndex)"
                                              class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                              <i class="fa fa-ellipsis-v"></i>
                                            </button>
                                           <div
                                              v-if="roleprivileges.includes('Subject Schedule Change Activity Status') || roleprivileges.includes('Subject Schedule Add New Form')"
                                              :id="popoverId(singleactivity.activityId, sIndex, pIndex, visit.__visitIndex)"
                                              popover class="visit-popup-menu"
                                              :style="popoverMenuStyle(singleactivity.activityId, sIndex, pIndex, visit.__visitIndex)">
                                              <button
                                                @click.prevent.stop="
                                                  openChangeStatusmodalforactivity(
                                                    singleactivity.actScheduleId,
                                                    singleactivity.status,
                                                    patient.patientId,
                                                    visit.visitNo,
                                                    visit.visitName,
                                                    visit.__visitIndex,
                                                    visit.sheduleId,
                                                    popoverId(singleactivity.activityId, sIndex, pIndex, visit.__visitIndex),
                                                    
                                                  )
                                                "
                                                class="popup-menu-block text-left w-100"
                                              >
                                                {{ $t('navigations.change status') }}
                                              </button>
                                              <button
                                                v-if="roleprivileges.includes('Subject Schedule Add New Form')" 
                                                @click.prevent="
                                                  openModal(
                                                    {
                                                      visitNo: visit.visitNo,
                                                      visitName: visit.visitName,
                                                      sheduleId: visit.sheduleId,
                                                      studyId: visit.studyId,
                                                      visitId: singleactivity.visitId,
                                                      actScheduleId: singleactivity.actScheduleId,
                                                      subjectId: singleactivity.subjectId,
                                                      activityId: singleactivity.activityId,
                                                      activityName: singleactivity.activityName,
                                                      siteId: site.siteID 
                                                      
                                                    },
                                                    patient.subjectId,
                                                    site.siteCode,
                                                    singleactivity.status,
                                                    popoverId(singleactivity.activityId, sIndex, pIndex, visit.__visitIndex),site.siteID 
                                                    
                                                    
                                                  )
                                                "
                                                class="popup-menu-block text-left w-100"
                                              >
                                                {{ $t('navigations.new form') }}
                                              </button>
                                            </div>
                                          </div>
                                        </label>
                                      <template v-if="visitFormObj[visit.visitNo + patient.patientId]">
                                        <ul>
                                          <li
                                            v-for="singlevisit in visitFormObj[
                                              visit.visitNo + patient.patientId
                                            ][activityindex]"
                                            :key="singlevisit.sheduleId"
                                          >
                                            <input
                                              v-if="singlevisit.templateName"
                                              type="checkbox"
                                              :id="formInputId(singlevisit, pIndex, visit.__visitIndex, activityindex)"
                                              @click.prevent="
                                                gotoform(singlevisit, patient.subjectId, site.siteCode)
                                              "
                                            />

                                            <label
                                              class="tree_label"
                                              :for="formInputId(singlevisit, pIndex, visit.__visitIndex, activityindex)"
                                              @click.stop
                                            >
                                              <div class="d-flex">
                                                <div class="d-flex align-items-center">
                                                  <p class="mb-0" style="max-width: 28ch;">
                                                    {{
                                                      singlevisit.formStatus === 'Completed'
                                                        ? singlevisit.templateName +
                                                          ' - ' +
                                                          (singlevisit.visitCompletedDate
                                                            ? filter(singlevisit.visitCompletedDate) + '-'
                                                            : '')
                                                        : singlevisit.templateName
                                                    }}
                                                  </p>

                                                  <span
                                                    class="badge custom-form-tooltip-wrapper"
                                                    @mouseenter="showPopover(`formStatus-${singlevisit.sheduleId}-${pIndex}-${visit.__visitIndex}`)"
                                                    @mouseleave="hidePopover(`formStatus-${singlevisit.sheduleId}-${pIndex}-${visit.__visitIndex}`)"
                                                    :popovertarget="`formStatus-${singlevisit.sheduleId}-${pIndex}-${visit.__visitIndex}`"
                                                    :style="`background-color: ${singlevisit.formStatusHex}; color: black;`"
                                                  >
                                                    {{ singlevisit.formStatus }}
                                                  </span>

                                                  <span
                                                    v-if="singlevisit.formStatusDescription"
                                                    popover
                                                    class="custom-form-tooltip-text"
                                                    :id="`formStatus-${singlevisit.sheduleId}-${pIndex}-${visit.__visitIndex}`"
                                                  >
                                                    {{ singlevisit.formStatusDescription }}
                                                  </span>
                                                </div>

                                                <button v-if="(singlevisit.formStatus !== 'Completed' && roleprivileges.includes('Subject Schedule Change Form Status')) ||
                                                    (singlevisit.formStatus == 'Completed' && singlevisit.sdvAssigned == false && singlevisit.isSdv == true)"
                                                    :popovertarget="popoverId(singlevisit.sheduleId, sIndex, pIndex, visit.__visitIndex)"
                                                    :style="popoverTriggerStyle(singlevisit.sheduleId, sIndex, pIndex, visit.__visitIndex)"
                                                    class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                                    <i class="fa fa-ellipsis-v"></i>
                                                  </button>
                                                  <div v-if="(singlevisit.formStatus !== 'Completed' && roleprivileges.includes('Subject Schedule Change Form Status')) ||
                                                    (singlevisit.formStatus == 'Completed' && singlevisit.sdvAssigned == false && singlevisit.isSdv == true)"
                                                    :id="popoverId(singlevisit.sheduleId, sIndex, pIndex, visit.__visitIndex)"
                                                    popover class="visit-popup-menu"
                                                    :style="popoverMenuStyle(singlevisit.sheduleId, sIndex, pIndex, visit.__visitIndex)">

                                                  <button
                                                    v-if="singlevisit.formStatus !== 'Completed' && roleprivileges.includes('Subject Schedule Change Form Status')"
                                                    @click.prevent.stop="
                                                      openChangeStatusmodal(
                                                        visit.studyId,
                                                        visit.visitNo,
                                                        patient.patientId,
                                                        visit.visitStatus,
                                                        visit.__visitIndex,
                                                        'Form',
                                                        popoverId(singlevisit.sheduleId, sIndex, pIndex, visit.__visitIndex),
                                                        visit.visitName,
                                                        singlevisit.formStatus,
                                                        singlevisit.formId,
                                                        singlevisit.sheduleId
                                                      )
                                                    "
                                                    class="popup-menu-block text-left w-100"
                                                  >
                                                    {{ $t('navigations.change status') }}
                                                  </button>
                                                  <button
                                                    v-if="
                                                      singlevisit.formStatus == 'Completed' &&
                                                      singlevisit.sdvAssigned == false &&
                                                      singlevisit.isSdv == true
                                                    "
                                                    @click.prevent.stop="
                                                      assignSdv(
                                                        singlevisit.formId,
                                                        singlevisit.templateId,
                                                        popoverId(
                                                          singlevisit.sheduleId,
                                                          sIndex,
                                                          pIndex,
                                                          visit.__visitIndex
                                                        )
                                                      )
                                                    "
                                                    class="popup-menu-block text-left w-100"
                                                  >
                                                    {{ $t('navigations.assign sdv') }}
                                                  </button>
                                                </div>
                                              </div>
                                            </label>
                                          </li>
                                        </ul>
                                      </template>

                                    </li>
                                  </ul>
                                </template>
                                </template>
                            </li>
                        </ul>
                          </template>

                            </li>
                        </ul>
                         </li> 
                      </ul>
                        </li>
                        </ul>
                  </li>
                </ul>
          </div>
      </div>

      <div v-if="roleprivileges.includes('Subject Schedule Recent Form')" class="col-lg-6 mb-1">
        <div class="ibox-body minheight">
          <!-- <div class="ibox-title style_2">
            <h5 class="float-left">{{ $t("navigations.recent form") }}</h5>
          </div> -->
          <div class="ibox-content minheight">
            <h4 class="float-left">{{ $t("navigations.recent form") }}</h4>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>{{ $t("navigations.site code") }}</th>
                    <th>{{ $t("navigations.subject id") }}</th>
                    <th class="sort_block" @click="SortSelectforms('visitName', 11)" id="11">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.visit name") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelectforms('formName', 0)" id="0">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.form name") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelectforms('createdUserName', 12)" id="12">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.uploaded by") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortSelectforms('createdAt', 13)" id="13">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.uploaded date") }}
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                      </div>
                    </th>
                    <th class="text-center">{{ $t("navigations.view") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in recentformList" :key="item.createdAt">
                    <td>{{ item.siteId }}</td>
                    <td>{{ item.subjectId }}</td>
                    <td>{{ item.visitName }}</td>
                    <td>{{ item.formName }}</td>
                    <td>{{ item.createdUserName }}</td>
                    <td>{{ filter(item.createdAt) }}</td>
                    <td class="text-center">
                      <i class="fa fa-eye editicon" aria-hidden="true" @click.prevent="
                        viewform(item.formId, item.siteId, item.subjectId)
                        "></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-3 mx-0">
              <div class="col-lg-12 mx-0 px-0">
                <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                  <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                    <v-pagination v-model="currentRecentformPage" :pages="totalformsPages" :range-size="1"
                      active-color="#618bd7" @update:modelValue="loadrecentForm" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-if="roleprivileges.includes('Submit Form Study Form')" class="ibox-body">
                        <div class="ibox-title style_2">
                            <h5 class="float-left">{{ $t("navigations.study forms") }}</h5>
                        </div>
                        <div class="ibox-content">
                            <table class="table table-bordered toggle-arrow-tiny">
                                <tbody>
                                    <tr v-for="list in formList" :key="list.visitId">
                                        <td @click="goToTemplate(false, list.templateId, null)">
                                            <a>{{ list.templateName }}</a>
                                           
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="row mx-0">
                                <div class="col-lg-12 mx-0 px-0">
                                    <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                                        <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                                            <v-pagination v-model="currentTemplatePage" :pages="totalTemplatePages"
                                                :range-size="0" active-color="#f4f9ff"
                                                @update:modelValue="loadTemplate" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
        </div>
      </div>
    </div>
  </div>

  <!-- Assign form popup starts -->
  <AssignEproPopup v-if="showAssignForm" :subjectId="selectedPatientId" :visitName="selectedVisitName"
    @closemodal="closeAssignFormModal" />
  <!-- Assign popup ends -->

  <!-- modal starts -->
  <div class="modal-wrapper">
    <div class="modal-container">
      <div class="titleclass">
        <h4 class="px-3 mt-1">{{ $t("navigations.add form") }}</h4>
        <div class="closebutton mt-1">
          <a style="color: white" class="close-link">
            <i class="fa fa-times" @click.prevent="closeModal"></i>
          </a>
        </div>
      </div>
      <div class="modelbody p-0">
        <!-- test -->
        <div class="mb-3 p-2">
          <div class="form-group">
            <div class="d-flex flex-column flex-lg-row">
              <div class="col-lg-12 my-2">
                <select class="form-control" placeholder="Search by Status" v-model="selectedTemplate">
                  <option value="" disabled>
                    {{ $t("navigations.select forms") }}
                  </option>
                  <option v-for="templates in templateList" :key="templates.templateId" :value="templates.templateId">
                    {{ templates.templateName }} ({{ templates.version }}) - {{ templates.languageCode.toUpperCase() }} 
                  </option>
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-center my-3">
              <button class="save_btn py-1 px-4" @click.prevent="
                gotofillform(
                  selectedVisit.visit,
                  selectedVisit.subjectId,
                  selectedVisit.siteCode
                )
                ">
                {{ $t("navigations.fill form") }}
              </button>
            </div>
          </div>
        </div>
        <!-- test -->
      </div>
    </div>
  </div>

  <!-- Assign form popup starts -->
  <AssignEproPopup v-if="showAssignTemplate" :subjectId="selectedPatientId" :visitName="selectedVisitName"
    @closemodal="closeAssignFormModal" />
  <!-- Assign popup ends -->



  <!-- modal starts -->
  <div class="modal-wrapper-changetemplate" v-if="showChangeTemplateModal">
    <div class="modal-container">
      <div class="titleclass">
        <h4 class="px-3 mt-1">{{ $t("navigations.change form") }}</h4>
        <div class="closebutton mt-1">
          <a style="color: white" class="close-link">
            <i class="fa fa-times" @click.prevent="closeModalchangetemolate"></i>
          </a>
        </div>
      </div>
      <div class="modelbody p-0">
        <!-- test -->
        <div class="mb-3 p-2">
          <div class="form-group">
            <div class="d-flex flex-column flex-lg-row">
              <div class="col-lg-12 my-2">
                <select class="form-control" placeholder="Search by Status" v-model="selectedTemplate">
                  <option value="" disabled selected>
                    {{ $t("navigations.select forms") }}
                  </option>
                  <option v-for="templates in temptemplatelist" :key="templates.templateId"
                    :value="templates.templateId">
                    {{ templates.templateName }} ({{ templates.version }}) - {{ templates.languageCode.toUpperCase() }}
                  </option>
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-center my-3">
              <button class="save_btn py-1 px-4" @click.prevent="assignTemplate()">
                {{ $t("navigations.save") }}
              </button>
            </div>
          </div>
        </div>
        <!-- test -->
      </div>
    </div>
  </div>

<customModal v-if="plannextvisitPopup == true" :containersm="true" @closeModal="closeplannextvisitModal()">
    <template #title>
      Plan Next Visit
    </template>
    <template #body>
      <div class="container mt-3">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">Visit Name</label>
            <select class="form-select no-arrow" v-model="createvisitobj.visitName" disabled @change="changeVisitDate">
              <option selected value="">All</option>
              <option v-for="schedule in (visitobj[createvisitobj.patientId]?.[createvisitobj.__patientIndex] || [])"
                :key="schedule.sheduleId" :value="schedule.visitName">
                {{ schedule.visitName }}
              </option>
            </select>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">Planned Visit Date</label>
            <flat-pickr v-model="oldvisitdatetDate" :config="dateTimePickerConfig" :disabled="true" class="fp-datetime-input" />
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">
              New Visit Date
              <sup><i class="fa fa-asterisk required"></i></sup>
            </label>
            <flat-pickr v-model="newvisitDate" :config="dateTimePickerConfig" class="fp-datetime-input" />
          </div>

        </div>

        <div class="mt-3">
          <h6 class="border-bottom pb-2 mb-3 small">
            Visit Window
          </h6>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Pre-Visit Date</label>
              <flat-pickr v-model="preVisitDate" :config="dateTimePickerConfig" class="fp-datetime-input" />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Post-Visit Date</label>
              <flat-pickr v-model="postVisitDate" :config="dateTimePickerConfig" class="fp-datetime-input" />
            </div>
          </div>
        </div>

        <div class="text-end mt-2">
          <button type="button" @click.prevent="Createnewvisitfun(createvisitobj)" class="btn btn-primary btn-sm px-4"
            :disabled="showLoader">
            <span v-if="showLoader == false">Save</span>
            <span v-else>
              <i class="fa fa-spinner fa-spin"></i>
            </span>
          </button>
        </div>

      </div>
    </template>

  </customModal>
  
    <!-- manage visit popup -->
    <customModal v-if="ManageVisitPopup == true" :containersm="true" @closeModal="closeManageVisitModal()">
      <template #title>
        Change Visit Date
      </template>
      <template #body>
        <div class="container mt-3">
          
          <div class="row justify-content-center">
            <div class="p-2">
  
              <!-- Visit Start Date -->
              <div class="col-md-12 d-flex align-items-center">
                <label class="form-label col-md-6 mb-0">Visit Start Date<sup><i
                      class="fa fa-asterisk required"></i></sup></label>
                <div class="col-md-6 px-0">
                  <flat-pickr v-model="actualVisitStartDate" :config="dateTimePickerConfig" class="fp-datetime-input w-100 visit-datetime-input" />
                </div>
              </div>
  
              <!-- Visit End Date -->
              <div class="col-md-12 d-flex align-items-center mt-2">
                <label class="form-label col-md-6 mb-0">Visit End Date</label>
                <div class="col-md-6 px-0">
                  <flat-pickr v-model="actualVisitEndDate" :config="dateTimePickerConfig" class="fp-datetime-input w-100 visit-datetime-input" />
                </div>
              </div>
  
              <!-- Completed Checkbox -->
              <div class="col-md-12 text-start">
                <div class="form-check mt-4">
                  <input class="form-check-input" type="checkbox" id="completedCheck" v-model="isCompleted" />
                  <label class="form-check-label" for="completedCheck">
                    Mark this visit as completed
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col text-end">
                  <button type="button" @click.prevent="updateactualvisitdates(managevisitobj)"
                    class="btn btn-primary btn-sm px-4" :disabled="showCreateLoader">
                    <span v-if="showCreateLoader == false">Save</span>
                    <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      </template>
    </customModal>

   <changeplanneddatePopup
      v-if="plannedvisitpopup"
      :visitobj="plannedvisitobject"
      @closeModal="plannedvisitpopup = false"
    />
  
   <CreateVideoCallSchedulePopUp v-if="CreateVideoCallSchedulePopUp" @cycleScheduled="onCycleScheduled" @closeModal="CreateVideoCallSchedulePopUp = false"
      :patientid="selectedPatientId" :fromPage="'FillForm'" />
  <CreateScheduleCyclePopUp v-if="CreateScheduleCyclePopUp" @closeModal="CreateScheduleCyclePopUp = false"
    @cycleScheduled="onCycleScheduled" :patientid="selectedPatientId" :cycleid="selectedCycleId" />
  <ManageCyclePopup v-if="ManageScheduleCyclePopUp" @closeModal="ManageScheduleCyclePopUp = false"
    @cycleScheduled="onCycleScheduled" :occurence="selectedOccurrence" :patientid="selectedPatientId" :cycleid="selectedCycleId" />
    <ChangeCycleStatusPopUp v-if="ChangeCycleStatusPopUp" @closeModal="ChangeCycleStatusPopUp = false"
      :patientid="selectedPatientId" :cycleid="selectedCycleId" :occurrence="selectedOccurrence" />
  <!-- Change schedule status  -->
  <ChangeSchedulestatus v-if="showChangeSchedule" :statusType="statusType" :changeStatus="changeStatus"
    :selectedScheduleId="scheduleId" :selectedFormId="selectedForm" @changeStatus="changedStatus()"
    @closeModal="closeChangeScheduleModal()" />
  <!-- End of Change schedule status  -->
  <!-- Change activity status  -->
  <ChangeactivityStatusPopup v-if="showChangeActivity" :activitystatusreload="activitystatusreload"
    :currentstatus="currentactivitystatus" :activityid="selectedActivityid" @changeStatus="changedactivityStatus"
    @closeModal="closeChangeactivityModal()" />

  <AssignFormSdvModal v-if="showSdvModal" :selectedFormId="selectedForm" @closeModal="closeSdvModal"
    :templateId="templateIdForSdv" />
   <!-- Manage visit new modal start -->
  <ManageVisit v-if="showManageVisitModal" :managevisitobj="managevisitobj" @saveVisit="refreshVisits" @closeModal="closeManageVisitModalNew" />
  <!-- Manage visit new modal end -->
  <!-- unscheduled visit  modal start -->
  <UnscheduledVisitModal v-if="showUnscheduledVisitModal" :patientId="patientId" @refreshVisits ="refreshVisits"
    @closeModal="closeUnscheduledVisitModal" />
  <!-- unscheduled visit  modal end -->
  <!-- Visit form list modal starts -->
  <div class="modal__schedule__wrapper" v-if="sohowFormModal">
    <div class="modal__schedule__container-forms">
      <div class="modal__schedule__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.forms") }}</h4>
        <div class="cursor-pointer">
          <i class="fa fa-times" title="Close" @click.prevent="closeFormsModal()"> </i>
        </div>
      </div>
      <div class="modal-body overflow-block-form">
        <div class="form-group row my-lg-2">
          <div class="d-flex flex-column flex-lg-row mb-lg-0">
            <div class="col-lg-12">
              <table class="table features-table">
                <tbody>
                  <p v-if="formlist.data == ''" class="mb-0 text-center">
                    {{ $t("navigations.no forms added") }}
                  </p>
                  <tr v-for="forms in formlist" :key="forms.sheduleId">
                    <td>{{ forms.templateName }}</td>

                    <td>
                      <span class="badge badge-grn" v-if="forms.visitStatus == 'Completed'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-danger" v-if="forms.visitStatus == 'Overdue'">{{ forms.visitStatus }}
                      </span>
                      <span class="badge badge-yellow" v-if="forms.visitStatus == 'Imminent'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-gray" v-if="forms.visitStatus == 'Withdrawn'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-blue" v-if="forms.visitStatus == 'Planned'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-orage" v-if="forms.visitStatus == 'Pending'">{{ forms.visitStatus }}
                      </span>
                    </td>
                    <td class="text-center">
                      <i class="fa fa-plus-square edit-delete" title="Fill Form"
                        @click.prevent="goTovisitTemplate([forms], forms.patientId)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Visit form list modal ends -->
  <!-- Visit form list modal starts -->
  <div class="modal__schedule__wrapper" v-if="sohowFormModalImminent">
    <div class="modal__schedule__container-forms">
      <div class="modal__schedule__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.forms") }}</h4>
        <div class="cursor-pointer">
          <i class="fa fa-times" title="Close" @click.prevent="closeImminentFormsModal()">
          </i>
        </div>
      </div>
      <div class="modal-body overflow-block-form">
        <div class="form-group row my-lg-2">
          <div class="d-flex flex-column flex-lg-row mb-lg-0">
            <div class="col-lg-12">
              <table class="table features-table">
                <tbody>
                  <p v-if="formlist.data == ''" class="mb-0 text-center">
                    {{ $t("navigations.no forms added") }}
                  </p>
                  <tr v-for="forms in formlist" :key="forms.sheduleId">
                    <td>{{ forms.templateName }}</td>
                    <td>
                      <span class="badge badge-grn" v-if="forms.visitStatus == 'Completed'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-danger" v-if="forms.visitStatus == 'Overdue'">{{ forms.visitStatus }}
                      </span>
                      <span class="badge badge-yellow" v-if="forms.visitStatus == 'Imminent'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-gray" v-if="forms.visitStatus == 'Withdrawn'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-blue" v-if="forms.visitStatus == 'Planned'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-orage" v-if="forms.visitStatus == 'Pending'">{{ forms.visitStatus }}
                      </span>
                    </td>
                    <td class="text-center">
                      <i class="fa fa-plus-square edit-delete" title="Fill Form"
                        @click.prevent="goTovisitTemplate([forms])"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Visit form list modal ends -->
</template>
<script src="./subject_schedule.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "./tree.css";

/* Tooltip box */
.custom-tooltip-text,
.custom-form-tooltip-text {
  position: absolute;
  inset: auto;
  margin: 0;
  bottom: anchor(top);
  right: anchor(right);
  background-color: #616161;
  color: white;
  padding: 6px 10px;
  font-size: 0.75rem;
  border-radius: 4px;
  border: none;
  max-width: 180px;
  white-space: normal;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-block-end: 4px;

}

.custom-tooltip-text:popover-open {
  display: grid;
}

.visit-ellipsis-btn {
  anchor-name: --manage-btn;
  border: 0;
}

.visit-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.visit-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.visit-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.visit-popup-menu>button {
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.visit-popup-menu>.popup-menu-block:hover,
.popup-submenu>div:hover {
  background-color: #e4eaf9;
}

@position-try --bottom {
  inset: auto;
  bottom: anchor(top);
  right: anchor(left);
}

/* CSS Popover Styles */
.linkstyle {
  cursor: pointer;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 18px;
  top: 6px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.plan-side-popup>div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup>div:hover {
  background-color: #e4eaf9;
}

.modal-container {
  background: #fff;
  width: min(50%, 90%);
  border-radius: 4px;
  position: fixed;
  transition: all 0.3s ease-in-out;
  height: auto !important;
  margin-top: 200px;
}

.modal-wrapper-changetemplate {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  pointer-events: auto;
  overflow: hidden;
  z-index: 9999;
}

.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  /* background-color: aquamarine;  */
  margin: 0;
  padding: 5%;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 17px;
  top: 12px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(90px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.modal__schedule__container-forms {
  background: #fff;
  width: min(30%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.badge-genre {
  background-color: #b6bdbf;
  color: #ffffff;
}

.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}

.modal__schedule__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

.minheight {
  min-height: 82vh;
}

:deep(.fp-datetime-input.flatpickr-input),
:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  color: inherit;
  display: block;
  width: 100%;
  min-height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
  transition: none;
}

:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  border-color: #145faf;
}

:deep(input.fp-datetime-input.flatpickr-input.active) {
  position: static !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  display: block !important;
}

:deep(.fp-datetime-input.flatpickr-input:disabled) {
  background-color: #e9ecef;
  cursor: not-allowed;
}
</style>
